module.exports = __webpack_public_path__ + "img/head_mr.543d3e47.jpeg";